import React from 'react';
import { connect } from 'react-redux';
import styles from './budget-container.scss';
import PropTypes from 'prop-types';
import { confirmTabChange } from '../../actions/index';
import * as selectors from '../../reducers';
import { getBubbleScale, getBubbleHexColor } from '../../modules/bubbleHelper';
import BudgetBubble from '../budget-bubble';
import { orderBy } from 'lodash';

class BudgetContainer extends React.Component {
  componentDidUpdate() {
    const { tabChangeRequested, confirmTabChange } = this.props;
    if (tabChangeRequested) {
      this.timeout = setTimeout(confirmTabChange, 300);
    }
  }

  componentWillUnmount() {
    clearTimeout(this.timeout);
  }

  renderTitle() {
    const { budgetType } = this.props;
    return budgetType === 'nobudget'
      ? 'budget not specified'
      : budgetType + ' projects';
  }

  renderSubtitle() {
    const { budgetType } = this.props;
    switch (budgetType) {
      case 'major':
        return 'Projects budget more than $10,000,000';
      case 'medium':
        return 'Projects budget more than $1,000,000';
      case 'small':
        return 'Projects budget less than $1,000,000';
      default:
        return '';
    }
  }

  renderBubbles() {
    const { projects, budgets } = this.props;
    const bubbleScale = getBubbleScale(budgets);
    return orderBy(projects, 'budget', ['asc']).map((project, i) => {
      const isNoBudget = !project.budget || project.budget === 0;
      const bubbleSize = isNoBudget ? 20 : bubbleScale(project.budget) * 2;
      const bubbleColor = getBubbleHexColor(project);
      return (
        <BudgetBubble
          key={i}
          color={bubbleColor}
          size={bubbleSize}
          project={project}
          isStriped={isNoBudget}
        />
      );
    });
  }

  render() {
    const { tabChangeRequested } = this.props;
    return (
      <div className={styles.budgetContainer}>
        <h3
          className={`${styles.budgetContainerHeading} ${tabChangeRequested
            ? styles.headingLeaving
            : ''}`}
        >
          {this.renderTitle()}
        </h3>
        <div
          className={`${styles.budgetContainerHeadingSub} ${tabChangeRequested
            ? styles.headingLeaving
            : ''}`}
        >
          {this.renderSubtitle()}
        </div>
        <div
          className={`${styles.bubbleContainer} ${tabChangeRequested
            ? styles.bubbleContainerLeaving
            : ''}`}
        >
          {this.renderBubbles()}
        </div>
      </div>
    );
  }
}
const mapDispatchToProps = {
  confirmTabChange,
};

const mapStateToProps = state => ({
  budgets: selectors.getBudgets(state),
  tabChangeRequested: selectors.tabChangeRequested(state),
});

BudgetContainer.propTypes = {
  projects: PropTypes.array,
  budgetType: PropTypes.string,
  budgets: PropTypes.array,
  tabChangeRequested: PropTypes.bool,
  confirmTabChange: PropTypes.func,
};

export default connect(mapStateToProps, mapDispatchToProps)(BudgetContainer);



// WEBPACK FOOTER //
// ./src/components/budget-container/budget-container.js